<template>
    <!-- 网站备份 -->
    <div class="lite-website myscroll">
        <!-- 主要内容 -->
        <div class="lite-website-content">
            <!-- 标题 -->
            <div class="website_title">
                <div class="website_title_main">{{ $t('language.leftBanner.liteWebsite') }}</div>
                <div class="website_title_desc">{{ $t('language.website.desc') }}</div>
            </div>
            <!-- 切换开关 -->
            <div class="website_switch">
                <div class="website_switch_item" :class="isClone ? '' : 'website_switch_select'" @click="switchTaskType('backup')">{{ $t('language.leftBanner.liteWebsite') }}</div>
                <div class="website_switch_item" :class="isClone ? 'website_switch_select' : ''" @click="switchTaskType('clone')">{{ $t('language.leftBanner.liteClone') }}</div>
            </div>
            <!-- 网站备份 -->
            <div class="website_backup" v-if="!isClone">
                <div class="website_from_to">
                    <!-- 来源 -->
                    <div class="backup_from_to" :class="boxFrom" @click="$refs.backupFromTree.show = true">
                        <!-- 空白内容 -->
                        <div class="backup_from_to_content">
                            <div class="backup_from_to_content_title">{{ $t('language.website.siteFromTitle') }}</div>
                            <div class="backup_from_to_content_desc">{{ $t('language.website.siteFromDesc') }}</div>
                        </div>
                        <!-- 已选择来源 -->
                        <liteSelectView :arrData="liteSelectFromData" class="backup_from_select" />
                    </div>
                    <!-- 中间箭头 -->
                    <div class="backup_center"></div>
                    <!-- 目标 -->
                    <div class="backup_from_to" :class="boxTo" @click="$refs.websiteToTree.show = true">
                        <!-- 空白内容 -->
                        <div class="backup_from_to_content">
                            <div class="backup_from_to_content_title">{{ $t('language.website.siteToTitle') }}</div>
                            <div class="backup_from_to_content_desc">{{ $t('language.website.siteToDesc') }}</div>
                        </div>
                        <!-- 已选择目标 -->
                        <liteSelectView :data="liteSelectToData" class="backup_to_select" />
                    </div>
                </div>
            </div>
            <!-- 网站克隆 -->
            <div class="website_clone" v-if="isClone">
                <div class="website_from_to">
                    <!-- 来源 -->
                    <div class="clone_from_to" :class="boxFrom">
                        <!-- 头部 -->
                        <div class="clone_head">
                            <div class="clone_head_title">{{ $t('language.cloudTransfer.from') }}</div>
                            <div class="clone_head_icon add_website" @click="readyAddWebsite()"></div>
                        </div>
                        <!-- 内容 -->
                        <div class="clone_body myscroll">
                            <!-- 网站列表 -->
                            <div class="website_item" v-for="website in websites" :key="website.id">
                                <!-- 网站 -->
                                <div class="website_item_box" @click="loadWebsiteChilds(website, 'from')">
                                    <div class="website_item_status" :class="{clone_tree_open:website.isOpen, clone_tree_close:!website.isOpen, clone_tree_loading:website.isLoadingChilds&&isLoadingChildsWay=='from'}"></div>
                                    <div class="website_item_icon clone_website"></div>
                                    <div class="website_item_name">{{ website.name }}</div>
                                </div>
                                <!-- 网站子集合 -->
                                <div class="website_item_childs" v-if="website.isOpen && website.childs && website.childs.length > 0">
                                    <!-- 站点或数据库 -->
                                    <div class="website_item_child" v-for="node in website.childs" :key="node.id" @click="selectNode('from',node)">
                                        <div class="website_item_status" :class="cloneLeftSelect==node.id ? 'clone_radio_select' : 'clone_radio_blank'"></div>
                                        <div class="website_item_icon" :class="'clone_'+node.type"></div>
                                        <div class="website_item_name">{{ node.name }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- 间隔 -->
                    <div class="clone_split"></div>
                    <!-- 中间内容 -->
                    <div class="clone_center">
                        <!-- 头部 -->
                        <div class="clone_head">
                            <div class="center_left_right">
                                <div class="center_left">
                                    <div class="clone_head_title">{{ $t('language.website.sourceServers') }}</div>
                                </div>
                                <div class="center_right">
                                    <div class="clone_head_title">{{ $t('language.website.targetServers') }}</div>
                                    <div class="clone_head_icon clone_delete" @click="cleanCloneSelect()"></div>
                                </div>
                            </div>
                        </div>
                        <!-- 内容 -->
                        <div class="clone_body myscroll">
                            <div class="center_left_right">
                                <div class="center_left">
                                    <div class="clone_select_item" v-for="(node, index) in cloneFromData">
                                        <div class="clone_select_item_icon" :class="'clone_'+node.type"></div>
                                        <div class="clone_select_item_name" :title="getDrive(node.did).name">{{ node.name }}</div>
                                        <div class="clone_select_item_delete"><div class="clone_delete" @click="deleteSelectItem(index)"></div></div>
                                    </div>
                                </div>
                                <div class="center_right">
                                    <div class="clone_select_item" v-for="(node, index) in cloneToData">
                                        <div class="clone_select_item_icon" :class="'clone_'+node.type"></div>
                                        <div class="clone_select_item_name" :title="getDrive(node.did).name">{{ node.name }}</div>
                                        <div class="clone_select_item_delete"><div class="clone_delete" @click="deleteSelectItem(index)"></div></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- 间隔 -->
                    <div class="clone_split"></div>
                    <!-- 目标 -->
                    <div class="clone_from_to" :class="boxTo">
                        <!-- 头部 -->
                        <div class="clone_head">
                            <div class="clone_head_title">{{ $t('language.cloudTransfer.to') }}</div>
                            <div class="clone_head_icon add_website" @click="readyAddWebsite()"></div>
                        </div>
                        <!-- 内容 -->
                        <div class="clone_body myscroll">
                            <!-- 网站列表 -->
                            <div class="website_item" v-for="website in websites" :key="website.id">
                                <!-- 网站 -->
                                <div class="website_item_box" @click="loadWebsiteChilds(website, 'to')">
                                    <div class="website_item_status" :class="{clone_tree_open:website.isOpen2, clone_tree_close:!website.isOpen2, clone_tree_loading:website.isLoadingChilds&&isLoadingChildsWay=='to'}"></div>
                                    <div class="website_item_icon clone_website"></div>
                                    <div class="website_item_name">{{ website.name }}</div>
                                </div>
                                <!-- 网站子集合 -->
                                <div class="website_item_childs" v-if="website.isOpen2 && website.childs && website.childs.length > 0">
                                    <!-- 站点或数据库 -->
                                    <div class="website_item_child" v-for="node in website.childs" :key="node.id" @click="selectNode('to',node)">
                                        <div class="website_item_status" :class="cloneRightSelect==node.id ? 'clone_radio_select' : 'clone_radio_blank'"></div>
                                        <div class="website_item_icon" :class="'clone_'+node.type"></div>
                                        <div class="website_item_name">{{ node.name }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 底部 -->
            <div class="website_bottom">
                <!-- 配置 -->
                <div class="website_options" @click="openOptionsDialog()">
                    <div class="website_options_icon clone_options"></div>
                    <div class="website_options_text">{{ $t('language.common.options') }}</div>
                </div>
                <!-- 计划 -->
                <div class="website_schedule" @click="openSchduleDialog()" v-if="!isClone">
                    <div class="website_schedule_icon" :class="checkedSchedule?'clone_check_box_select':'clone_check_box_blank'" @click.stop="checkedOpen()"></div>
                    <div class="website_schedule_text">{{ $t('language.common.schedule') }}</div>
                </div>
                <!-- 名称 -->
                <div class="website_task_name">
                    <div class="website_task_name_icon clone_edit"></div>
                    <div class="website_task_name_text" v-if="!isEditName" @click="startEditTaskName()">{{ taskName }}</div>
                    <!-- 编辑名称 -->
                    <div class="website_task_name_edit" v-else>
                        <input ref="taskNameInput" type="text" v-model="taskName" @blur="okEditTaskName()">
                        <div class="icon-util name-sure" @click="okEditTaskName()"></div>
                        <div class="icon-util name-cancel" @click="cancelEditTaskName()"></div>
                    </div>
                </div>
                <!-- 创建按钮 -->
                <div class="website_task_create" @click="addTask(checkedSchedule && !isClone)">
                    <div class="website_task_create_icon" :class="isClone ? 'liteClone' : 'liteWebsite'"></div>
                    <div class="website_task_create_text">{{ (checkedSchedule && !isClone) ? $t('language.cloudTransfer.addTaskOnly') : (isClone ? $t('language.website.cloneNow') : $t('language.cloudBackup.backupNow')) }}</div>
                    <div class="website_task_create_icon_right clone_down" v-if="checkedSchedule && !isClone" @click.stop="showOnlyCreate=!showOnlyCreate"></div>
                    <div class="website_task_create_icon_right_blank" v-else></div>
                </div>
                <!-- 仅创建任务 -->
                <div class="website_task_create_only" v-if="checkedSchedule && !isClone && showOnlyCreate" @click="addTask(false)">{{ isClone ? $t('language.website.addTaskNow') : $t('language.cloudTransfer.addBackupTaskNow') }}</div>
                <!-- 创建任务动画 -->
                <transition name="flow">
                    <div class="flow-icon" v-show="flowShow" id="transferFlow">
                        <div class="icon transfer-task-position cloudTransfer flow-icon-position"></div>
                    </div>
                </transition>
            </div>
        </div>
        <!-- 底部背景 -->
        <div class="task-buttom"></div>
        <!-- 网站备份目标选择 -->
        <liteSelect ref="websiteToTree" :showCheckbox="false" :showDBDrive="false" :showFileNode="false" :showNewFolder="true" @selectDone="selectDoneTo" />
        <!-- 网站备份源选择 -->
        <liteSelect ref="backupFromTree" :showCheckbox="true" :onlyWebsite="true" :showFileNode="true" :showNewFolder="false" @selectDone="selectDoneFrom" />
        <!-- 设置项 -->
        <liteOptions ref="websiteOptions" :data="liteOptionsData" @ok="okOptions" />
        <!-- 计划 -->
        <websiteScheduleDialog ref="websiteScheduleDialog"></websiteScheduleDialog>
        <!-- 加载中 -->
        <div class="lite-website-loading" v-show="fullscreenLoading"></div>
        <!-- 添加网站 -->
        <liteAddDrive :auth="auth" @submit="addWebsite()" />
        <!-- 升级弹窗 -->
        <upgradeNewDialog ref="upgradeNewDialog"></upgradeNewDialog>
    </div>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import { Message } from "element-ui";
import commonstate from '@/js/constant.js';
import requestUtils from '@/js/request_util.js';
import commonUtils from "@/js/workspace/common_util.js";
import taskListUtils from "@/js/workspace/task_list_util.js";
import liteSelect from "@/components/workspace/lite_select";
import liteSelectView from "@/components/workspace/lite_select_view";
import liteOptions from "@/components/workspace/lite_options";
import websiteScheduleDialog from "@/components/popup/cloud_transfer_popups/task_schedule_popup";
import liteAddDrive from "@/components/workspace/lite_add_drive";
import upgradeNewDialog from "@/components/popup/upgrade_popups/upgrade_account_new_popup";

export default {
    name: "liteWebsite",
    components: {
        liteSelect,
        liteSelectView,
        liteOptions,
        websiteScheduleDialog,
        liteAddDrive,
        upgradeNewDialog,
    },
    data() {
        return {
            // 创建任务动画
            flowShow: false,
            // 任务名称
            taskName: "",
            // 任务名称旧值
            taskNameOld: "",
            // 是否是克隆任务
            isClone: false,
            // 是否正在编辑任务名称
            isEditName: false,
            // 备份源
            liteSelectToData: null,
            // 备份目标
            liteSelectFromData: null,
            // 设置项
            liteOptionsData: {
                listThread: commonUtils.getUser().vip ? 3 : 1,
                runThread: commonUtils.getUser().vip ? 10 : 2,
                email: '',
                cron: '',
                sameName: 'skipRename',
                excludeNames: [],
                allowedExtensions: [],
                type: 'website',
                onlyAdd: false,
                schedules: {disabled:true},
                delete: false,
                keepDate: false,
                logFile: false,
                inOneFolder: false,
                syncMode: '',
            },
            // 勾选了计划
            checkedSchedule: false,
            // 计划
            pSchedules: {},
            // 显示仅创建任务
            showOnlyCreate: false,
            // 全屏加载
            fullscreenLoading: false,
            // 克隆源
            cloneFromData: [],
            // 克隆目标
            cloneToData: [],
            // 未选来源或目标的动画效果
            boxFrom: '',
            boxTo: '',
            // 添加网站参数准备
            auth: {
                show: false,
                loading: false,
                type: "",
                name: "",
                website: {
                    sites: [],
                    dbs: [],
                },
            },
            // 正在创建任务
            createTasking: false,
            // 克隆左右当前选择项
            cloneLeftSelect: '',
            cloneRightSelect: '',
            // 正在展开左边还是右边
            isLoadingChildsWay: '',
        }
    },
    computed: {
        // 只显示网站
        websites() {
            return this.$store.state.drives.filter(drive => {
                    return drive.type=='Website';
                });
        },
    },
    mounted() {
        // 初始化任务名称
        this.taskName = commonUtils.getTaskTxt(this) + " " + (this.$store.state.tasks.length + 1);
        // 单击空白隐藏“仅创建任务”
        document.addEventListener('click', this.hideOnlyCreate)
    },
    beforeDestroy() {
        // 取消监听器
        window.removeEventListener('click', this.hideOnlyCreate)
    },
    methods: {
        // 删除已选择的项
        deleteSelectItem(index) {
            if (this.cloneFromData.length-1 >= index) {
                this.cloneFromData.splice(index, 1);
            }
            if (this.cloneToData.length-1 >= index) {
                this.cloneToData.splice(index, 1);
            }
            if (this.cloneFromData.length == this.cloneToData.length) {
                this.cloneLeftSelect = '';
                this.cloneRightSelect = '';
            }
        },
        // 获取任务列表
        listTasks(callback) {
            this.sendRequest("/task/list", {}, (data) => {
                this.$store.state.tasks = data;
                if (callback) callback();
            })
        },
        clearPageChoose() {
            // 有用，不能删除
        },
        // 隐藏“仅创建任务”
        hideOnlyCreate() {
            this.showOnlyCreate = false
        },
        // 获取云盘
        getDrive(id) {
            for (let i = 0; i < this.$store.state.drives.length; i++) {
                let drive = this.$store.state.drives[i];
                if (drive.id === id) {
                    return drive;
                }
            }
            return null;
        },
        // 清理克隆已选择节点
        cleanCloneSelect() {
            this.cloneFromData = [];
            this.cloneToData = [];
            this.cloneLeftSelect = '';
            this.cloneRightSelect = '';
        },
        // 加载云盘
        loadDrives(callback) {
            this.sendRequest("/drive/list", {}, (data) => {
                const drives = this.$store.state.drives || [];
                data.forEach(newItem => {
                    const oldItem = drives.find(d => d.id === newItem.id);
                    if (oldItem) {
                        Object.assign(oldItem, newItem);
                    } else {
                        drives.push(newItem);
                    }
                });
                if (callback) {
                    callback();
                }
            })
        },
        // 确定添加网站
        addWebsite() {
            if (this.auth.loading) return;
            this.auth.loading = true;
            this.sendRequest("/drive/auth", this.auth, (data) => {
                this.auth.loading = false;
                this.auth.show = false;
                this.loadDrives(() => {
                    this.$store.state.needLoadDriveInfo = true;
                });
            }, () => {
                this.auth.loading = false;
            });
        },
        // 准备添加网站
        readyAddWebsite() {
            this.auth.type = "Website";
            this.auth.name = this.addCloudNameInit("Website");
            this.auth.loading = false;
            this.auth.website.sites = [];
            this.auth.website.dbs = [];
            this.auth.show = true;
        },
        // 添加云盘名称初始化
        addCloudNameInit(name) {
            let names = [];
            for (let i = 0; i < this.$store.state.drives.length; i++) {
                names.push(this.$store.state.drives[i].name);
            }
            // 返回一个不重复的名称，如果有同名就添加数字
            let count = 1;
            let temp = name;
            while (names.indexOf(temp) != -1) {
                temp = name + " " + count;
                count++;
            }
            return temp;
        },
        // 克隆选择节点
        selectNode(type, node) {
            const fromCount = this.cloneFromData.length;
            const toCount = this.cloneToData.length;
            if (type == 'from') {
                // 选择源
                if (fromCount < toCount) {
                    if (!this.checkSameDrive(this.cloneToData, node)) {
                        if (this.checkMatchType(this.cloneToData, node)) {
                            if (!this.checkNodeAdded(this.cloneFromData, node, this.cloneToData)) {
                                this.cloneFromData.push(node);
                                this.cloneLeftSelect = '';
                                this.cloneRightSelect = '';
                            }
                        }
                    }
                } else if (fromCount == toCount) {
                    if (!this.checkNodeAdded(this.cloneFromData, node, this.cloneToData)) {
                        this.cloneFromData.push(node);
                        this.cloneLeftSelect = node.id;
                    }
                } else if (fromCount > toCount) {
                    if (this.cloneFromData[fromCount-1] != node) {
                        if (!this.checkNodeAdded(this.cloneFromData, node, this.cloneToData)) {
                            this.cloneFromData.pop();
                            this.cloneFromData.push(node);
                            this.cloneLeftSelect = node.id;
                        }
                    }
                }
            } else if (type == 'to') {
                // 选择目标
                if (toCount < fromCount) {
                    if (!this.checkSameDrive(this.cloneFromData, node)) {
                        if (this.checkMatchType(this.cloneFromData, node)) {
                            if (!this.checkNodeAdded(this.cloneToData, node, this.cloneFromData)) {
                                this.cloneToData.push(node);
                                this.cloneLeftSelect = '';
                                this.cloneRightSelect = '';
                            }
                        }
                    }
                } else if (toCount == fromCount) {
                    if (!this.checkNodeAdded(this.cloneToData, node, this.cloneFromData)) {
                        this.cloneToData.push(node);
                        this.cloneRightSelect = node.id;
                    }
                } else if (toCount > fromCount) {
                    if (this.cloneToData[toCount-1] != node) {
                        if (!this.checkNodeAdded(this.cloneToData, node, this.cloneFromData)) {
                            this.cloneToData.pop();
                            this.cloneToData.push(node);
                            this.cloneRightSelect = node.id;
                        }
                    }
                }
            }
        },
        // 克隆选择，禁止同云盘克隆
        checkSameDrive(nodes, node) {
            const same = nodes[nodes.length-1].did == node.did;
            if (same) {
                Message.warning(this.$t('language.website.cloneSameNodeWarning'));
            }
            return same;
        },
        // 克隆选择，源和目标类型需要匹配
        checkMatchType(nodes, node) {
            const match = nodes[nodes.length-1].type == node.type;
            if (!match) {
                Message.warning(this.$t('language.website.cloneTypeMismatchWarning'));
            }
            return match;
        },
        // 克隆选择，禁止重复选择
        checkNodeAdded(nodes, node, otherNodes) {
            if (nodes.length + 1 == otherNodes.length) {
                var arr = [];
                for (var i=0; i<nodes.length; i++) {
                    if (nodes[i].id == node.id) {
                        arr.push(otherNodes[i]);
                    }
                }
                var otherId = otherNodes[otherNodes.length-1].id;
                for (var i=0; i<arr.length; i++) {
                    if (arr[i].id == otherId) {
                        Message.warning(this.$t('language.website.clonePairExistsWarning'));
                        return true;
                    }
                }
            }
            return false;
        },
        // 克隆，加载网站下面的站点和数据库
        loadWebsiteChilds(drive, type) {
            if (!drive.isLoadingChilds) {
                if (drive.childs == undefined) {
                    this.isLoadingChildsWay = type;
                    // 第一次加载
                    Vue.set(drive, 'isLoadingChilds', true);
                    this.sendRequest("/file/list", { id: drive.id, param: { node: null, start: null } }, (data) => {
                        data.nodes.forEach(node => {
                            node.did = drive.id;
                        });
                        Vue.set(drive, 'childs', data.nodes);
                        if (type == 'from') {
                            Vue.set(drive, 'isOpen', true);
                        }
                        if (type == 'to') {
                            Vue.set(drive, 'isOpen2', true);
                        }
                        Vue.set(drive, 'isLoadingChilds', false);
                    }, () => {
                        Vue.set(drive, 'isLoadingChilds', false);
                    });
                } else {
                    // 已经加载，展开或折叠
                    if (type == 'from') {
                        if (drive.isOpen) {
                            Vue.set(drive, 'isOpen', false);
                        } else {
                            Vue.set(drive, 'isOpen', true);
                        }
                    }
                    if (type == 'to') {
                        if (drive.isOpen2) {
                            Vue.set(drive, 'isOpen2', false);
                        } else {
                            Vue.set(drive, 'isOpen2', true);
                        }
                    }
                }
            }
        },
        // 创建任务
        addTask(onlyCreate) {
            // 检测是否正在创建任务
            if (this.createTasking) return;
            // 检测任务名
            if (!this.taskName) {
                Message.warning(this.$t('language.website.taskNameRequired'));
                return;
            }
            // 确定创建任务后是否要运行
            this.liteOptionsData.onlyAdd = onlyCreate;
            if (this.isClone) {
                // 创建克隆任务
                const fromCount = this.cloneFromData.length;
                const toCount = this.cloneToData.length;
                // 检测是否选择源
                if (fromCount==0 || fromCount<toCount) {
                    this.boxFrom = "box-shake";
                    setTimeout(() => {
                        this.boxFrom = "box-shakeOrigin";
                    }, 100);
                    return;
                }
                // 检测是否选择目标
                if (toCount==0 || toCount<fromCount) {
                    this.boxTo = "box-shake";
                    setTimeout(() => {
                        this.boxTo = "box-shakeOrigin";
                    }, 100);
                    return;
                }
                // 不用计划
                this.liteOptionsData.schedules = {disabled:true};
                // 源和目标数据
                let fromDatas = [];
                let toDatas = [];
                this.cloneFromData.forEach(node => {
                    fromDatas.push({did:node.did, node:node});
                });
                this.cloneToData.forEach(node => {
                    toDatas.push({did:node.did, node:node});
                });
                // 创建任务的参数准备
                const taskParam = {
                    type: "clone",
                    name: this.taskName,
                    param: {
                        froms: fromDatas,
                        tos: toDatas,
                        options: this.liteOptionsData,
                    }
                }
                // 开始创建任务
                let that = this;
                this.createTasking = true;
                this.sendRequest("/task/create", taskParam, () => {
                    for (let i = 0; i < fromCount; i++) { 
                        taskListUtils.exeSuccessEnd('transferFlow', 'taskList', [], that);
                    }
                    this.cleanCloneSelect();
                    this.liteOptionsData = {
                        listThread: commonUtils.getUser().vip ? 3 : 1,
                        runThread: commonUtils.getUser().vip ? 10 : 2,
                        email: '',
                        cron: '',
                        sameName: 'skip',
                        excludeNames: [],
                        allowedExtensions: [],
                        type: 'clone',
                        onlyAdd: false,
                        schedules: {disabled:true},
                        delete: false,
                        keepDate: false,
                        logFile: false,
                        inOneFolder: false,
                        syncMode: '',
                    };
                    this.listTasks(() => {
                        const newTaskName = commonUtils.judgeRepeatTaskName([], that);
                        this.taskName = newTaskName;
                    });
                    this.createTasking = false;
                    if (!this.$store.state.isLiteMode) {
                        Message.warning(this.$t('language.website.switchToPlusForWebsiteTasks'));
                    }
                });
            } else {
                // 创建备份任务
                // 检测是否选择源
                if (this.liteSelectFromData==null || this.liteSelectFromData.length==0) {
                    this.boxFrom = "box-shake";
                    setTimeout(() => {
                        this.boxFrom = "box-shakeOrigin";
                    }, 100);
                    return;
                }
                // 检测是否选择目标
                if (this.liteSelectToData == null) {
                    this.boxTo = "box-shake";
                    setTimeout(() => {
                        this.boxTo = "box-shakeOrigin";
                    }, 100);
                    return;
                }
                // 确定计划
                if (this.checkedSchedule) {
                    this.liteOptionsData.schedules = this.pSchedules;
                    this.liteOptionsData.schedules.disabled = false;
                } else {
                    this.liteOptionsData.schedules = {disabled:true};
                }
                // 创建任务的参数准备
                const taskParam = {
                    type: "website",
                    name: this.taskName,
                    tdid: this.liteSelectToData.did,
                    param: {
                        froms: this.liteSelectFromData,
                        to: this.liteSelectToData.node,
                        options: this.liteOptionsData,
                    }
                }
                // 开始创建任务
                let that = this;
                this.createTasking = true;
                this.sendRequest("/task/create", taskParam, () => {
                    for (let i = 0; i < this.liteSelectFromData.length; i++) { 
                        taskListUtils.exeSuccessEnd('transferFlow', 'taskList', [], that);
                    }
                    this.liteSelectFromData = null;
                    this.liteSelectToData = null;
                    this.liteOptionsData = {
                        listThread: commonUtils.getUser().vip ? 3 : 1,
                        runThread: commonUtils.getUser().vip ? 10 : 2,
                        email: '',
                        cron: '',
                        sameName: 'skipRename',
                        excludeNames: [],
                        allowedExtensions: [],
                        type: 'website',
                        onlyAdd: false,
                        schedules: {disabled:true},
                        delete: false,
                        keepDate: false,
                        logFile: false,
                        inOneFolder: false,
                        syncMode: '',
                    };
                    if (this.checkedSchedule) {
                        this.checkedSchedule = false;
                        this.pSchedules = {
                            type: "Now"
                        }
                        this.clearAllTableData();
                    }
                    this.listTasks(() => {
                        const newTaskName = commonUtils.judgeRepeatTaskName([], that);
                        this.taskName = newTaskName;
                    });
                    this.createTasking = false;
                    if (!this.$store.state.isLiteMode) {
                        Message.warning(this.$t('language.website.switchToPlusForWebsiteTasks'));
                    }
                });
            }
        },
        // 取消计划
        clearAllTableData() {
            this.$refs.websiteScheduleDialog.$refs.weekly.weekArr = [];
            this.$refs.websiteScheduleDialog.$refs.monthly.monthArr = [];
            this.$refs.websiteScheduleDialog.$refs.daily.checkArr = [];
            this.$refs.websiteScheduleDialog.$refs.daily.dailyTimeArr = [];
            this.$refs.websiteScheduleDialog.$refs.daily.dailyDisableFlage = true;
            this.$refs.websiteScheduleDialog.$refs.daily.onceDisableFlage = true;
            this.$refs.websiteScheduleDialog.oldSchedules = {};
        },
        // 取消计划或打开计划弹窗
        checkedOpen() {
            if (this.checkedSchedule) {
                this.checkedSchedule = false;
                this.pSchedules = {
                    type: "Now"
                }
                this.clearAllTableData();
            } else {
                this.$refs.websiteScheduleDialog.$refs.daily.checkArr = [0];
                this.openSchduleDialog();
            }
        },
        // 打开计划弹窗
        openSchduleDialog() {
            this.$refs.websiteScheduleDialog.taskSchduleShow = true;
            this.$refs.websiteScheduleDialog.initPopup();
        },
        // 切换备份或克隆
        switchTaskType(type) {
            if (type == 'backup') {
                this.isClone = false;
                this.liteOptionsData.type = 'website';
                this.liteOptionsData.sameName = 'skipRename';
            }
            if (type == 'clone') {
                this.isClone = true;
                this.liteOptionsData.type = 'clone';
                this.liteOptionsData.sameName = 'skip';
            }
        },
        // 打开设置弹窗
        openOptionsDialog() {
            this.$refs.websiteOptions.init();
            if (this.liteOptionsData.type == 'clone') {
                this.$refs.websiteOptions.activeName = 'clone';
            } else {
                this.$refs.websiteOptions.activeName = 'email';
            }
            this.$refs.websiteOptions.show = true;
        },
        // 确定设置
        okOptions(data) {
            this.liteOptionsData = data;
        },
        // 准备编辑任务名
        startEditTaskName() {
            this.taskNameOld = this.taskName;
            this.isEditName = true;
            this.$nextTick(() => {
                this.$refs.taskNameInput.select();
            });
        },
        // 确定任务名称
        okEditTaskName() {
            setTimeout(() => {
                if (this.taskName == "") {
                    this.taskName = this.taskNameOld;
                }
                this.isEditName = false;
            }, 200);
        },
        // 取消编辑任务名称
        cancelEditTaskName() {
            this.taskName = this.taskNameOld;
            this.isEditName = false;
        },
        // 备份目标选择
        selectDoneTo(data) {
            this.liteSelectToData = data;
        },
        // 备份源选择
        selectDoneFrom(data) {
            this.liteSelectFromData = data;
        },
        // 不显示加载中的请求
        noLoading(path) {
            return ["/file/list","/task/create"].includes(path);
        },
        // 发送Lite请求
        sendRequest(path, data, callback, errorCallback) {
            if (!this.noLoading(path)) {
                this.fullscreenLoading = true;
            }
            requestUtils.doLiteRequest(path, data)
                .then(res => {
                    if (!this.noLoading(path)) {
                        this.fullscreenLoading = false;
                    }
                    let code = res.code
                    let msg = res.msg
                    if (msg == undefined) {
                        msg = res.message;
                    }
                    if (code == 200) {
                        // 请求成功
                        if (callback) {
                            callback(res.data)
                        }
                    } else if (code == 400) {
                        // 请求失败
                        Message.warning(msg)
                        if (errorCallback) {
                            errorCallback(res)
                        }
                    } else {
                        if (msg == "Unauthorized") {
                            // 未登录
                            location.href = location.host.includes("localhost") ? "http://localhost:8080/share/123" : "https://" + location.host + "/sign"
                        } else {
                            // 服务器异常
                            if (path != "/drive/info") {
                                this.$message({
                                    message: msg,
                                    type: 'error',
                                    duration: 5000,
                                    showClose: true
                                })
                            }
                            if (errorCallback) {
                                errorCallback(res)
                            }
                        }
                    }
                }, err => {
                    if (!this.noLoading(path)) {
                        this.fullscreenLoading = false;
                    }
                    // 请求异常
                    Message.error(err)
                    if (errorCallback) {
                        errorCallback(err)
                    }
                });
        }
    }
}
</script>

<style scoped>
/* 网站备份 */
.lite-website {
    box-sizing: border-box;
    position: relative;
    top: 90px;
    height: calc(100% - 90px);
    background-color: #f2f7fe;
    overflow: auto;
}
/* 主要内容 */
.lite-website-content {
    width: 100%;
    height: 100%;
    min-height: 680px;
    position: absolute;
    z-index: 2;
    left: 0;
    top: 0;
}
/* 底部背景 */
.lite-website .task-buttom {
    position: fixed;
    z-index: 1;
    bottom: 0;
    left: 0;
}
/* 标题 */
.website_title {
    height: 60px;
    margin-top: 0px;
    margin-bottom: 80px;
    padding: 0 30px;
}
/* 主标题 */
.website_title_main {
    font-size: 18px;
    color: #222222;
    font-weight: bold;
    margin-bottom: 6px;
}
/* 标题描述 */
.website_title_desc {
    font-size: 14px;
    color: #6F7886;
}
/* 切换开关 */
.website_switch {
    height: 38px;
    margin-bottom: 40px;
    padding: 0 130px;
}
/* 切换项 */
.website_switch>.website_switch_item {
    font-size: 14px;
    color: #5562B4;
    height: 38px;
    line-height: 38px;
    padding: 0 40px;
    background-color: #FFF;
    float: left;
    cursor: pointer;
    user-select: none;
}
/* 切换选中 */
.website_switch>.website_switch_select {
    background: #5562B4;
    color: #FFFFFF;
}
/* 网站备份、网站克隆 主体内容 */
.website_from_to {
    height: 100%;
    min-height: 300px;
    display: flex;
    flex-direction: row;
}
/* 网站备份 */
.website_backup {
    height: calc(100% - 470px);
    min-height: 300px;
    padding: 0 130px;
}
/* 网站备份来源目标 */
.backup_from_to {
    flex-grow: 1;
    border: 8px solid #E2EBFD;
    background: #FFFFFF;
    position: relative;
    cursor: pointer;
    transition: transform 0.1s cubic-bezier(0.645, 0.045, 0.355, 1);
}
/* 网站备份目标选中内容 */
.backup_to_select {
    text-align: center;
}
/* 网站备份来源选中内容 */
.backup_from_select {
    text-align: center;
}
/* 网站备份来源目标空白内容 */
.backup_from_to_content {
    text-align: center;
    height: 100px;
    position: absolute;
    z-index: 1;
    margin: auto;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
}
/* 网站备份来源目标空白内容标题 */
.backup_from_to_content_title {
    color: #A3ADBD;
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 50px;
}
/* 网站备份来源目标空白内容描述 */
.backup_from_to_content_desc {
    font-size: 14px;
    font-weight: normal;
    color: #BDBDBD;
}
/* 网站备份中间箭头 */
.backup_center {
    width: 260px;
    background-image: url("../../assets/images/workspace/arrow.png");
    background-repeat: no-repeat;
    background-position: center;
}
/* 网站克隆 */
.website_clone {
    height: calc(100% - 470px);
    padding: 0 130px;
}
/* 克隆来源目标 */
.clone_from_to {
    flex: 1;
    border: 8px solid #E2EBFD;
    background: #FFFFFF;
    display: flex;
    flex-direction: column;
    transition: transform 0.1s cubic-bezier(0.645, 0.045, 0.355, 1);
}
/* 克隆间隔 */
.clone_split {
    width: 20px;
}
/* 克隆中间内容 */
.clone_center {
    flex: 2;
    border: 8px solid #E2EBFD;
    background: #FFFFFF;
}
/* 头部 */
.clone_head {
    height: 38px;
    background: #F2F7FE;
}
/* 内容 */
.clone_body {
    flex-grow: 1;
    padding: 10px 0;
    overflow: auto;
    user-select: none;
}
.clone_center>.clone_body {
    height: calc(100% - 58px);
}
/* 头部标题 */
.clone_head_title {
    color: #C1CBE3;
    font-size: 18px;
    font-weight: bold;
    margin: 7px 16px;
    display: inline-block;
}
/* 头部图标 */
.clone_head_icon {
    width: 20px;
    height: 20px;
    float: right;
    margin-top: 9px;
    margin-right: 16px;
    cursor: pointer;
    background-repeat: no-repeat;
    background-position: center;
}
.clone_center .clone_head_icon {
    float: none;
    position: absolute;
    z-index: 1;
    right: 0;
    top: 0;
}
/* 添加网站 */
.add_website {
    background-image: url("../../assets/images/lite/icon/add_website.svg");
}
/* 编辑图标 */
.clone_edit {
    background-image: url("../../assets/images/lite/icon/edit.svg");
}
/* 删除图标 */
.clone_delete {
    background-image: url("../../assets/images/lite/icon/delete.svg");
}
/* 网站 */
.clone_website {
    background-image: url("../../assets/images/lite/icon/website.svg");
}
/* 站点 */
.clone_site {
    background-image: url("../../assets/images/lite/icon/site.svg");
}
/* 数据库 */
.clone_db {
    background-image: url("../../assets/images/lite/icon/db.svg");
}
/* 复选框-已选择 */
.clone_check_box_select {
    background-image: url("../../assets/images/lite/icon/check_box_select.svg");
}
/* 复选框-空白 */
.clone_check_box_blank {
    background-image: url("../../assets/images/lite/icon/check_box_blank.svg");
}
/* 单选框-已选择 */
.clone_radio_select {
    background-image: url("../../assets/images/lite/icon/radio_select.svg");
}
/* 单选框-空白 */
.clone_radio_blank {
    background-image: url("../../assets/images/lite/icon/radio_blank.svg");
}
/* 树-关闭 */
.clone_tree_close {
    background-image: url("../../assets/images/lite/icon/tree_close.svg");
}
/* 树-打开 */
.clone_tree_open {
    background-image: url("../../assets/images/lite/icon/tree_open.svg");
}
/* 树-加载 */
.clone_tree_loading {
    background-image: url("../../assets/images/lite/icon/tree_loading.svg");
    animation: rotateLoading 1s linear infinite;
}
@keyframes rotateLoading {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
/* 配置 */
.clone_options {
    background-image: url("../../assets/images/lite/icon/options.svg");
}
/* 上 */
.clone_up {
    background-image: url("../../assets/images/lite/icon/create_up.svg");
}
/* 下 */
.clone_down {
    background-image: url("../../assets/images/lite/icon/create_down.svg");
}
/* 中间左右布局 */
.center_left_right {
    display: flex;
    flex-direction: row;
    height: 100%;
}
/* 左边 */
.center_left {
    flex: 1;
}
/* 右边 */
.center_right {
    flex: 1;
    position: relative;
}
/* 已选择项 */
.clone_select_item {
    height: 44px;
    cursor: default;
    width: 100%;
    position: relative;
}
/* 已选择-图标 */
.clone_select_item_icon {
    width: 24px;
    height: 24px;
    display: inline-block;
    vertical-align: middle;
    margin-left: 16px;
}
/* 已选择-文字 */
.clone_select_item_name {
    font-size: 14px;
    color: #2E2F33;
    font-weight: 500;
    height: 44px;
    line-height: 44px;
    display: inline-block;
    width: calc(100% - 50px);
    vertical-align: middle;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
/* 已选择-删除 */
.clone_select_item_delete {
    height: 44px;
    width: 200%;
    text-align: right;
    box-sizing: border-box;
    background: rgba(0, 106, 255, 0.05);
    position: absolute;
    z-index: 1;
    top: 0px;
    display: none;
}
.clone_select_item:hover>.clone_select_item_delete {
    display: block;
}
.center_right .clone_select_item_delete {
    left: -100%;
}
.clone_select_item_delete>.clone_delete {
    width: 20px;
    height: 20px;
    background-repeat: no-repeat;
    background-position: center;
    display: inline-block;
    margin-top: 10px;
    margin-right: 10px;
    cursor: pointer;
}
/* 网站框 */
.website_item_box:hover {
    background: rgba(0, 106, 255, 0.05);
    cursor: pointer;
}
/* 网站-状态 */
.website_item_status {
    width: 16px;
    height: 16px;
    display: inline-block;
    vertical-align: middle;
    margin-left: 14px;
    margin-right: 10px;
}
/* 网站-图标 */
.website_item_icon {
    width: 24px;
    height: 24px;
    display: inline-block;
    vertical-align: middle;
}
/* 网站-名称 */
.website_item_name {
    height: 44px;
    line-height: 44px;
    font-size: 14px;
    font-weight: 500;
    color: #2E2F33;
    display: inline-block;
    width: calc(100% - 80px);
    vertical-align: middle;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
/* 网站-子元素集合 */
.website_item.website_close .website_item_childs {
    display: none;
}
/* 网站-单个子元素（站点或数据库） */
.website_item_child:hover {
    background: rgba(0, 106, 255, 0.05);
    cursor: pointer;
}
/* 子元素缩进 */
.website_item_child>.website_item_status {
    margin-left: 48px;
}
/* 子元素名称宽度 */
.website_item_child>.website_item_name {
    width: calc(100% - 114px);
}
/* 底部 */
.website_bottom {
    height: 50px;
    margin-top: 80px;
    padding: 0 130px;
    position: relative;
}
/* 选项 */
.website_options {
    display: inline-block;
    cursor: pointer;
}
/* 选项图标 */
.website_options_icon {
    width: 16px;
    height: 16px;
    display: inline-block;
    vertical-align: middle;
}
/* 选项文字 */
.website_options_text {
    font-size: 16px;
    color: #5562B4;
    display: inline-block;
    height: 16px;
    line-height: 16px;
    vertical-align: middle;
}
/* 计划 */
.website_schedule {
    display: inline-block;
    margin-left: 50px;
    cursor: pointer;
}
/* 计划复选框 */
.website_schedule_icon {
    width: 16px;
    height: 16px;
    display: inline-block;
    vertical-align: middle;
}
/* 计划文字 */
.website_schedule_text {
    font-size: 16px;
    color: #5562B4;
    display: inline-block;
    height: 16px;
    line-height: 16px;
    vertical-align: middle;
}
/* 任务名称 */
.website_task_name {
    display: inline-block;
    margin-left: 50px;
    cursor: pointer;
}
/* 任务名称图标 */
.website_task_name_icon {
    width: 16px;
    height: 16px;
    display: inline-block;
    vertical-align: middle;
    margin-right: 5px;
}
/* 任务名称文字 */
.website_task_name_text {
    font-size: 16px;
    color: #5562B4;
    display: inline-block;
    height: 34px;
    line-height: 34px;
    vertical-align: middle;
}
/* 任务名称编辑 */
.website_task_name_edit {
    display: inline-block;
    position: relative;
    height: 34px;
    vertical-align: middle;
}
/* 任务名称编辑框 */
.website_task_name_edit>input {
    display: inline-block;
    margin-top: 0px;
    padding-right: 50px;
    width: 200px;
    color: #5562B4;
    font-size: 16px;
}
/* 任务名称编辑图标 */
.website_task_name_edit>.icon-util {
    display: inline-block;
    position: absolute;
    z-index: 1;
    top: 6px;
}
/* 确定编辑任务名称 */
.website_task_name_edit>.name-sure {
    right: 26px;
}
/* 取消编辑任务名称 */
.website_task_name_edit>.name-cancel {
    right: 4px;
}
/* 创建任务按钮 */
.website_task_create {
    border-radius: 8px;
    background: #5562B4;
    height: 50px;
    line-height: 50px;
    padding-left: 20px;
    float: right;
    cursor: pointer;
    user-select: none;
}
.website_task_create:hover {
    background-color: #3250c9;
}
/* 创建任务按钮图标 */
.website_task_create_icon {
    width: 22px;
    height: 22px;
    display: inline-block;
    vertical-align: middle;
    margin-right: 10px;
}
/* 创建任务文字 */
.website_task_create_text {
    font-size: 16px;
    color: #FFFFFF;
    height: 22px;
    line-height: 22px;
    display: inline-block;
    vertical-align: middle;
}
/* 向下箭头 */
.website_task_create_icon_right {
    width: 50px;
    height: 48px;
    display: inline-block;
    vertical-align: middle;
    background-repeat: no-repeat;
    background-position: center;
    border-radius: 6px;
}

/* 创建任务按钮右边空白 */
.website_task_create_icon_right_blank {
    width: 20px;
    height: 48px;
    display: inline-block;
    vertical-align: middle;
}

/* 仅创建任务 */
.website_task_create_only {
    position: absolute;
    z-index: 1;
    right: 130px;
    top: 54px;
    background-color: #FFF;
    border: 1px solid #5562B4;
    white-space: nowrap;
    height: 40px;
    line-height: 40px;
    padding-right: 10px;
    padding-left: 40px;
    background-image: url("../../assets/images/workspace/newNav/add_blue.svg");
    background-position: 10px center;
    background-repeat: no-repeat;
    cursor: pointer;
    color: #6F7886;
    user-select: none;
}

.website_task_create_only:hover {
    background-color: #cbdcff;
}

/* 加载中 */
.lite-website-loading {
    position: absolute;
    z-index: 1;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
}

/* 简洁圆环旋转动画 */
.lite-website-loading::after {
    content: "";
    width: 48px;
    height: 48px;
    border: 4px solid #DCE4F5;
    border-top-color: #5562B4;
    border-radius: 50%;
    animation: spin_website 0.8s linear infinite;
}

@keyframes spin_website {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}
</style>



// WEBPACK FOOTER //
// src/components/workspace/lite_website.vue